import { Box, Container, Grid, Typography } from "@mui/material";
import * as React from "react";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

const PageDoesNotExists = () => {
  return (
    <Container>
      <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "80vh" }}>
        <Grid item xs={12} md={6}>
          <SentimentVeryDissatisfiedIcon sx={{ width: 60, height: 60, color: "red" }} />
          <Typography variant="h4" gutterBottom color={"red"}>
            <p>Elion Platform</p>
            <b>404 page not found</b>
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};
export default PageDoesNotExists;
